let documentTitle = "Enrollment Application";
let API_BASE = "https://jayi2stkod.execute-api.us-east-1.amazonaws.com/api/";

if (
  window.location.origin != "https://devenrollment.uslegalservices.net" &&
  window.location.origin != "http://localhost:8080"
) {
  API_BASE = "https://vvv15k44dc.execute-api.us-east-1.amazonaws.com/api/";
}

export default {
  documentTitle,
  API_BASE
};
